import { Selection } from "@tiptap/pm/state";

import type { EditorView } from "@tiptap/pm/view";

export function isDocSelected(view: EditorView) {
  const { selection, doc } = view.state;
  return selection.from === 1 && selection.to === Selection.atEnd(doc).to;
}
